/**
 * Picker portfeli — pill row. Pomija portfele typu 'shared' jeśli excludeShared
 * (dla transferu — nie można przelać do agregatora).
 */
import type { Wallet } from '../../features/wallets/walletsStore';
import { safeColor, haptic } from '../../lib/utils';

interface Props {
  wallets: Wallet[];
  value: string;
  onChange: (id: string) => void;
  excludeShared?: boolean;
  excludeId?: string;
  label?: string;
}

export function WalletPicker({ wallets, value, onChange, excludeShared, excludeId, label }: Props) {
  const visible = wallets.filter((w) => {
    if (excludeShared && w.type === 'shared') return false;
    if (excludeId && w.id === excludeId) return false;
    return true;
  });

  if (visible.length === 0) {
    return <p className="text-sm text-slate-500 dark:text-slate-400">Brak dostępnych portfeli</p>;
  }

  return (
    <div className="space-y-2">
      {label && (
        <p className="text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
          {label}
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        {visible.map((w) => {
          const selected = w.id === value;
          const color = safeColor(w.color, '#0ea5e9');
          return (
            <button
              key={w.id}
              type="button"
              onClick={() => {
                haptic('light');
                onChange(w.id);
              }}
              aria-pressed={selected}
              className={`px-3.5 py-2 rounded-full border text-sm font-medium flex items-center gap-2 transition-all ${
                selected
                  ? 'border-sky-500 dark:border-sky-400 ring-2 ring-sky-500/20 bg-white dark:bg-slate-800 text-slate-900 dark:text-white'
                  : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300'
              }`}
            >
              <span
                className="inline-block w-2.5 h-2.5 rounded-full"
                style={{ backgroundColor: color }}
                aria-hidden="true"
              />
              {w.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
